<template>
  <div class="listBox">
    <div>
      <h6 class="color-text">Subcategorias</h6>
    </div>
    <div class="listWrap">
      <ul>
        <li v-for="subcategoria in subcategorias" :key="subcategoria">
          <label class="check-control large">
            <span>{{ subcategoria.descricao }}</span>
            <input type="checkbox" class="check " :value="subcategoria.idsubcategorialoja" v-model="subcategoria.selected" @change="select" />
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scope: {
      type: Array
    }
  },
  watch: {
    scope ( value ) {
      // console.log("watch scope:", value) 
      this.subcategorias = value
      this.$nextTick(() => {
        this.setup()
      })
    }
  },
  data () {
    return {
      selected: [],
      subcategorias: []
    }
  },
  mounted () {

  },
  methods: {
    setup () {
      this.subcategorias.map( k => {
        if ( k.selected ) k.selected = true
      })
    },
    select() {
      this.$emit('select', this.subcategorias)
    }
  }
}
</script>

<style lang="scss" scoped>
  .listBox {
    display: flex; flex-direction: column;
    align-content: stretch; align-items: stretch;
    width: 100%;
    border-radius: $border-radius;
    background-color: $color-secondary;
    margin-top: $mg;

    >div {
      h6 {
        margin: 0;
        padding: 0;
      }

      &:not(.listWrap) {
        padding: $hmg_small;
      }
      &.listWrap {
        margin-bottom: $hmg
      }

      ul {
        height: 250px; width: 100%;
        overflow: auto;
        @extend %scrollbar;
        padding: 0; margin: 0;
        border-top: 1px solid $color-bg;
        border-bottom: 1px solid $color-bg;

        li {
          width: 100%;
          padding: 0; margin: 0;
          list-style: none;
          @extend %transition_3o;

          &:hover {
            background-color: $color-bg
          }
        }
      }
    }
  }
</style>